module.exports = __webpack_public_path__ + "static/media/SRHirsch.0135d99e.png";